// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ContractorNew } from './contractor-new';
import { User } from './user';

/**
 * 
 * @export
 * @interface LearningRequest
 */
export interface LearningRequest {
    /**
     * 
     * @type {string}
     * @memberof LearningRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LearningRequest
     */
    number: string;
    /**
     * 
     * @type {ContractorNew}
     * @memberof LearningRequest
     */
    contractor?: ContractorNew;
    /**
     * 
     * @type {string}
     * @memberof LearningRequest
     */
    clientType?: string;
    /**
     * 
     * @type {string}
     * @memberof LearningRequest
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof LearningRequest
     */
    clientName?: string;
    /**
     * 
     * @type {string}
     * @memberof LearningRequest
     */
    resourceType: string;
    /**
     * 
     * @type {string}
     * @memberof LearningRequest
     */
    resourceId: string;
    /**
     * 
     * @type {string}
     * @memberof LearningRequest
     */
    resourceTitle?: string;
    /**
     * 
     * @type {number}
     * @memberof LearningRequest
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof LearningRequest
     */
    status: LearningRequestStatusEnum;
    /**
     * 
     * @type {Array<User>}
     * @memberof LearningRequest
     */
    users: Array<User>;
    /**
     * 
     * @type {object}
     * @memberof LearningRequest
     */
    payload: object;
    /**
     * 
     * @type {Date}
     * @memberof LearningRequest
     */
    formedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof LearningRequest
     */
    startedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof LearningRequest
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof LearningRequest
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof LearningRequest
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof LearningRequest
     */
    responsibleId: string;
    /**
     * 
     * @type {string}
     * @memberof LearningRequest
     */
    responsibleName?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum LearningRequestStatusEnum {
    NotProcessed = 'not_processed',
    WaitingPayment = 'waiting_payment',
    Learning = 'learning',
    LearningFinished = 'learning_finished',
    DocumentsReady = 'documents_ready',
    Completed = 'completed',
    Cancelled = 'cancelled'
}



